import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M.84 8.333v3.334a.667.667 0 0 0 .668.666h.666a2 2 0 1 0 4 0h4a2 2 0 1 0 4 0h.667a.667.667 0 0 0 .667-.666v-8a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2V5H4.174a2 2 0 0 0-1.6.8l-1.6 2.133a.4.4 0 0 0-.046.094l-.04.073a.7.7 0 0 0-.047.233m10.668 4a.667.667 0 1 1 1.333 0 .667.667 0 0 1-1.333 0M6.84 3.667A.667.667 0 0 1 7.508 3h6a.667.667 0 0 1 .666.667V11h-.52a2 2 0 0 0-2.96 0H6.841zm-1.333 4H2.84l.8-1.067a.67.67 0 0 1 .533-.267h1.334zm-2 4.666a.667.667 0 1 1 1.334 0 .667.667 0 0 1-1.334 0M2.174 9h3.334v1.853A2 2 0 0 0 2.694 11h-.52z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })